<template>
  <v-card>
    <div style="position: relative">
      <div style="position: absolute; left: 0px; top: 0px">
        <v-btn icon @click="$router.back()"><v-icon>arrow_back</v-icon></v-btn>
      </div>
      <h1 class="text-pagename text-xs-center">Deleted Rider</h1>
    </div>
    <riderVeiws :riders="riders" hideAction></riderVeiws>
  </v-card>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import riderVeiws from "@/components/back-office/Rider/RiderListViews.vue";
export default {
  data: function () {
    return {};
  },
  components: {
    riderVeiws,
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/",
      },
      {
        text: "Select service",
        disabled: false,
        href: "/weserve_admin_login/control/" + this.$route.params.province,
      },
      {
        text: "Rider",
        disabled: false,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/rider/riderinhouse",
        // href:
        //    "/weserve_admin_login/control/" +
        //   this.$route.params.province +
        //   "/rider/riderdashboard"
      },
      {
        text: "Rider management",
        disabled: true,
      },
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  },
  created() {
    // this.$store.dispatch('fetchRiderListBack/getRiderList')
  },
  computed: {
    ...mapState({
      riders: (state) => state.fetchRiderListBack.riders_deleted,
    }),
  },
};
</script>
